import styled from "@emotion/styled";

export const OverflowContainer = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
